import "./style/global.less";
import "./style/own.less";
import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { legacy_createStore as createStore } from "redux";
import { Provider } from "react-redux";
import { ConfigProvider } from "@arco-design/web-react";
// import zhCN from '@arco-design/web-react/es/locale/zh-CN';
import enUS from "@arco-design/web-react/es/locale/en-US";
import plPL from "./locale/pl-PL/pl-PL";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import axios from "axios";
import rootReducer from "./store";
import PageLayout from "./layout";
import { GlobalContext } from "./context";
import Login from "./pages/login";
import checkLogin from "./utils/checkLogin";
import changeTheme from "./utils/changeTheme";
import useStorage from "./utils/useStorage";
import "./mock";
import { Host } from "@/utils/common";

const store = createStore(rootReducer);

function Index() {
  // const [lang, setLang] = useStorage('arco-lang', 'pl-PL');
  const [lang, setLang] = useStorage("arco-lang", "en-US");
  const [theme, setTheme] = useStorage("arco-theme", "light");

  function getArcoLocale() {
    return enUS;

    // switch (lang) {
    //   case 'pl-PL':
    //     return plPL;
    //   case 'en-US':
    //     return enUS;
    //   default:
    //     return plPL;
    // }
  }

  // function fetchUserInfo() {
  //   axios.get('/api/user/userInfo').then((res) => {
  //     store.dispatch({
  //       type: 'update-userInfo',
  //       payload: { userInfo: res.data },
  //     });
  //   });
  // }

  // useEffect(() => {
  // if (checkLogin()) {
  //   fetchUserInfo();
  // } else if (window.location.pathname.replace(/\//g, '') !== 'login') {
  //   window.location.pathname = '/login';
  // }
  // }, []);

  function fetchAuthInfo() {
    axios
      .get(Host + "/api/v1/whoami")
      .then((res) => {
        store.dispatch({
          type: "update-authInfo",
          payload: { authInfo: res.data },
        });
      })
      .catch((err) => {
        // check if forbidden
        if (err.response.status === 403) {
          if (window.location.pathname.startsWith("/login")) {
            return;
          }
          // @ts-ignore
          window.location = "/login?redirect=" + window.location.pathname;
        }
      });
  }

  useEffect(() => {
    fetchAuthInfo();
  }, []);

  useEffect(() => {
    changeTheme(theme);
  }, [theme]);

  const contextValue = {
    lang,
    setLang,
    theme,
    setTheme,
  };

  return (
    <BrowserRouter>
      <ConfigProvider
        locale={getArcoLocale()}
        componentConfig={{
          Card: {
            bordered: false,
          },
          List: {
            bordered: false,
          },
          Table: {
            border: false,
          },
        }}
      >
        <Provider store={store}>
          <GlobalContext.Provider value={contextValue}>
            <Switch>
              {/*<Route path="/login" component={Login} />*/}
              <Route path="/" component={PageLayout} />
            </Switch>
          </GlobalContext.Provider>
        </Provider>
      </ConfigProvider>
    </BrowserRouter>
  );
}

ReactDOM.render(<Index />, document.getElementById("root"));
